export interface Scrollable {
  _scrollTop: number;
}

export interface ScrollAnimation {
  // Scroll until this position.
  scrollEnd: number;

  // Wait this number of milliseconds initially, after which start scrolling. Can be
  // missing, in which case start scrolling immediately.
  initialDelayTimeInMs?: number;

  // The number of milliseconds between consecutive scrolls.
  intervalTimeInMs: number;

  // Scroll this percentage to reach the end. I.e., if we have to scroll 900px
  // and this is 0.1, in this scroll iteration we'll scroll 90px, leaving
  // 810px left to scroll. In the next iteration, we'll scroll 81px.
  percentage: number;

  // Scroll this number of times.
  steps: number;
}

function linearStep(start: number, end: number, percentage: number): number {
  return start + (end - start) * percentage;
}

export async function smoothScroll(element: Scrollable, scrollAnimation: ScrollAnimation): Promise<void> {
  let id;
  let step = 0;

  return new Promise(resolve => {
    const scroll = () => {
      id = setInterval(() => {
        if (step === scrollAnimation.steps) {
          clearInterval(id);
          resolve();
        } else {
          step++;
          element._scrollTop = linearStep(element._scrollTop, scrollAnimation.scrollEnd, scrollAnimation.percentage);
        }
      }, scrollAnimation.intervalTimeInMs);
    };

    if (scrollAnimation.initialDelayTimeInMs) {
      setTimeout(scroll, scrollAnimation.initialDelayTimeInMs);
    } else {
      scroll();
    }
  });
}
